import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ResourceConsumptionBaseState } from './resource-consumption-base.model';
import { FEATURE_NAME } from './resource-consumption-base.constant';

// Base selectors
export const selectResourceConsumptionBaseState = createFeatureSelector<ResourceConsumptionBaseState>(FEATURE_NAME);

export const selectResourceConsumptionBaseGroupedData = createSelector(
  selectResourceConsumptionBaseState,
  (state) => state.data
);

export const selectResourceConsumptionTrackedItems = createSelector(
  selectResourceConsumptionBaseState,
  (state) => state.trackedItems
);

// Resource consumption specific selectors - data is keyed by projectId directly
export const selectResourceConsumptionProjectGroupMap = createSelector(
  selectResourceConsumptionBaseGroupedData,
  (data) => data // Returns {projectId: {rangeKey: {data: [...]}}}
);

